// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '../environmentConfig';

export const config: EnvironmentConfig = {
  production: false,
  kknowContentApi: 'https://api.dev.cosmose.cloud/kaikai-now-content-api/v1',
  kknowTargetingApi: 'https://targeting.kaikai-now.dev.cosmose.cloud/v1',
  apiRoot: 'https://api.dev.cosmose.cloud/uaa',
  mindBrushApi: 'https://mindbrush-pub.dev.cosmose.cloud',
  kknowAdminApi: 'https://kaikai-now-admin-pub.dev.cosmose.cloud',
  apiKey: 'a2Fpa2FpLW5vdy1hZG1pbjpyaXcwMU15ckd6R0JuMDg=',
  prefix: 'Bearer',
};
